var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgRectanglePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 300,
    viewBox: "0 0 360 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.803 86.5356C539.167 190.178 464.578 323.203 343.101 323.203L31.4645 323.203C-86.9371 323.203 -160.964 195.059 -101.814 92.4908C-75.6733 47.1623 -28.2865 18.2272 23.9774 15.6808L328.52 0.842825C385.331 -1.92515 439.123 26.5381 468.791 75.0661L475.803 86.5356Z",
    fill: "url(#paint0_linear_2985_5955)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2985_5955",
    x1: 512.718,
    y1: 289.131,
    x2: -14.5434,
    y2: -27.2602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4940CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D992DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRectanglePhone);
export default __webpack_public_path__ + "static/media/BgRectanglePhone.ab198ffc15ce823d14ccfe1fb8bd2518.svg";
export { ForwardRef as ReactComponent };